<!--LIGNE SÉPARATRICE EN DÉGRADER DE CHAQUE COTÉ-->
<template>
    <div class="s-currencyInput">


        <!--<span v-if="append == null || append == ''">
            <div>
                <b-input :name="Name" :id="Name" type="text" v-model="displayValue" :min="min" :max="max" @blur="isInputActive = false" @focus="isInputActive = true" pattern="[0-9]*" inputmode="numeric"/>
            </div>
        </span> 

        <span v-else-if="append != ''">
            <div>
                <b-input-group size="md" :append="append">
                    <b-input :name="Name" :id="Name" type="text" v-model="displayValue" :min="min" :max="maxValue" @blur="isInputActive = false" @focus="isInputActive = true" pattern="[0-9]*" inputmode="numeric"/>
                </b-input-group>
            </div>
        </span>-->
<!--, $emit(onKeyPressAux)">-->
        <!--<div>-->
            <b-row align-v="center">
                <b-col cols>
                    <span v-if="onBlur">
                        <b-input-group size="md" :prepend="prepend" :append="append">
                            <b-input 
                                :disabled="disabled" 
                                style="height: 39px;" 
                                :name="name" 
                                :id="name" 
                                :type="type" 
                                v-model="displayValue" 
                                :min="min" 
                                :max="max" 
                                autocomplete="off"
                                @blur="isInputActive = false, sendOnBlur()" 
                                @focus="isInputActive = true, valideValueChange = value" 
                                pattern="[0-9]*" 
                                inputmode="numeric"
                                @keypress="$emit(onKeyPress, valueKeyPress)">
                            </b-input>
                        </b-input-group>
                    </span>

                    <span v-else>
                        <b-input-group size="md" :prepend="prepend" :append="append">
                            <b-input 
                                :disabled="disabled" 
                                style="height: 39px;" 
                                :name="name" 
                                :id="name" 
                                :type="type" 
                                :step="step"
                                v-model="displayValue" 
                                :min="min" 
                                :max="max" 
                                autocomplete="off"
                                @blur="isInputActive = false" 
                                @focus="isInputActive = true" 
                                pattern="[0-9]*" 
                                inputmode="numeric"
                                @keypress="$emit(onKeyPress, valueKeyPress)">
                            </b-input>
                        </b-input-group>
                    </span>

                </b-col>

                <b-col v-if="minus" cols="2" align="center">
                    <b-icon-dash-square-fill variant="danger" scale="2" class="fontSize18" @click="removeValue()"></b-icon-dash-square-fill>
                </b-col>
                <b-col v-if="plus" cols="2" align="center">
                    <b-icon-plus-square-fill variant="success" scale="2" class="fontSize18" @click="addValue()"></b-icon-plus-square-fill>
                </b-col>

            </b-row>
        <!--</div>-->
     
    </div>
</template>

<script>

import fromExponential from 'from-exponential';
export default{
    name: "s-currencyInput",
    /*
    value :         valeur a retourner dans le get/set
    append :        symbole à afficher à la fin du champs
    decimal :       nombre de décimal à afficher 
    name :          nom du composant
    min :           valeur minimal
    max :           valeur maximal
    prepend :       symbole à afficher au début
    disabled :      true pour désactiver
    onKeyPress :    fonction à retourner au parent dans le cas d'un keypress
    valueKeyPress : valeur à retourner au parent dans le cas d'un keypress
    minus :         si on affiche le bouton -
    plus :          si on affiche le bouton +
    valueChange :   fonction a executer dans le parent lors d'un changement de valeur
    enteredValue :  valeur entrer au moment du lost focus. Si le montant est modifier à 
                    partir d'une fonction externe, cela permet de revenir à la valeur
                    d'origine.
    */
    //props: ['value', 'append', 'decimal', 'name', 'min', 'max', 'prepend', 'step', 'disabled', 
    //        'onKeyPress', 'valueKeyPress', 'minus', 'plus', 'valueChange', 'enteredValue',
    //        'onBlur'],
    props: {
        value: [String, Number],
        append: String,
        type: {
            type: String,
            required: false,
            default: "number"
        },
        decimal: {
            type: Number,
            required: false,
            default: 0
        },
        name: String,
        min: {
            type: [String, Number],
            required: false,
            default: 0
        },
        max: [String, Number],
        prepend:String,
        step: {
            type: [String, Number],
            required: false,
            default: 1
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        onKeyPress: Function,
        valueKeyPress: String,
        minus:Boolean,
        plus: Boolean,
        valueChange:Function,
        enteredValue:Number,
        onBlur:String
    },
    data: function() {
        return {
            isInputActive: false,
            valideValueChange: 0
        }
    },
    methods:{
        sendOnBlur(){
            /*
            Valider si un changement de montant a été effectué 
            à la perte du focus, si aucun changement alors on ne fait rien
            sinon, on mets à jour la valeur entrer et on envoie le onBlur()
            */
            if (this.value != this.valideValueChange)
                {
                    this._enteredValue = this.value
                    this.$emit(this.onBlur)
                }
        },
        addValue(){
            if((this.max && this.displayValue < this.max) || typeof this.max == "undefined" ) {
                let step = fromExponential(this.step)
                this.displayValue = (parseFloat(this.value.toString())+ parseFloat(step))
                if(this._getDecimal != 0) {
                    this.displayValue = (parseFloat(this.value.toString())+ parseFloat(step)).toFixed(this._getDecimal)
                }
            }
        },
        removeValue(){
            if((this.min && this.displayValue > this.min) || typeof this.min == "undefined" ) {
                let step = fromExponential(this.step)
                this.displayValue = (parseFloat(this.value.toString() )- parseFloat(step))
                if(this._getDecimal != 0) {
                    this.displayValue = (parseFloat(this.value.toString())- parseFloat(step)).toFixed(this._getDecimal)
                }
            }
        }
    },
    computed: {
        _getDecimal() {
            let newDecimal = this.decimal
            if(this.decimal == 0) {
                let step = fromExponential(this.step)
                if(!Number.isInteger(step)) {
                    const indexOfFirst = step.toString().indexOf(".");
                    if(indexOfFirst > -1) {
                        newDecimal = step.toString().split('.')[1].length
                    }
                }
            }
            return parseInt(newDecimal)
        },
        _enteredValue: {
            get: function() {return this.enteredValue},
            set: function(modifiedValue){this.$emit('update:enteredValue', modifiedValue)}
        },
        displayValue: {
             get: function() {
                let sendValue = this.value
                if(sendValue == null || sendValue == undefined)
                {sendValue = 0}
                if (this.isInputActive) {
                    // Cursor is inside the input field. unformat display value for user
                    return sendValue
                } else {
                    return this._getDecimal==0 ? parseFloat(sendValue.toString()) : parseFloat(sendValue.toString()).toFixed(this._getDecimal)
                }
            },
            set: function(modifiedValue) {


                // Recalculate value after ignoring "$" and "," in user input
                // eslint-disable-next-line no-useless-escape
                let newValue = parseFloat(modifiedValue.toString().replace(/[^\d\.]/g, ""))
                // Ensure that it is not NaN
                if (isNaN(newValue)) {
                    newValue = 0
                }
                // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                // $emit the event so that parent component gets it

                if (newValue > this.max)
                    {
                        this.value = this.max
                        this.displayValue = this.max
                        newValue = this.max
                    }

                //console.log(newValue + " : " + this.min)
                if (newValue < this.min)
                    {
                        this.value = this.min
                        this.displayValue = this.min
                        newValue = this.min
                    }

                this.$emit('input', newValue)

                if (this.valueChange)
                {
                    this.$emit(this.valueChange, newValue)
                }
                let convertedValue = parseFloat(modifiedValue.toString())
                if (!isNaN(convertedValue)) {
                    this.$emit('input', modifiedValue)
                }
                
            }
        }
    }
}

</script>

<style lang="scss" scoped>

</style>